import { Auth } from "aws-amplify";
import axios from "axios";
import { setIsLoading } from "../../redux/loader/action";
import store from "../../redux/store";

function password_generator(len) {
  let length = len ? len : 10;
  let string = "abcdefghijklmnopqrstuvwxyz"; //to upper
  let numeric = "0123456789";
  let punctuation = "!@#$%^&*()_+~`|}{[]:;?><,./-=";
  let password = "";
  let character = "";
  let crunch = true;
  while (password.length < length) {
    let entity1 = Math.ceil(string.length * Math.random() * Math.random());
    let entity2 = Math.ceil(numeric.length * Math.random() * Math.random());
    let entity3 = Math.ceil(punctuation.length * Math.random() * Math.random());
    let hold = string.charAt(entity1);
    hold = password.length % 2 == 0 ? hold.toUpperCase() : hold;
    character += hold;
    character += numeric.charAt(entity2);
    character += punctuation.charAt(entity3);
    password = character;
  }
  password = password
    .split("")
    .sort(function () {
      return 0.5 - Math.random();
    })
    .join("");
  return password.substr(0, len);
}

function authenticateWithMicrosoftToken(username, microsoftIdToken) {
  store.dispatch(setIsLoading(true));

  Auth.signIn(username).then((cognitoUser) => {
    cognitoUser.clearCachedDeviceKeyAndPassword();

    // after sign in is started we need to continue with authentication and we sent microsft token
    Auth.sendCustomChallengeAnswer(cognitoUser, microsoftIdToken);
  });
}

const getMicrosoftPicture = async (token) => {
  try {
    const url = `${process.env.REACT_APP_GET_MICROSOFT_PROFILE_PICTURE}/?token=${token}`;
    const respp = await axios.get(url);
    return respp.data.data.Location;
  } catch (error) {
    console.log("error: ", error);
    return null;
  }
};

async function signUpOrSignInWithMicrosoftToken(response) {
  const picture = await getMicrosoftPicture(response.accessToken);
  store.dispatch(setIsLoading(true));

  const attributes = {};
  const username = response.account.username;
  const microsoftIdToken = response.idToken;
  attributes["custom:microsoftToken"] = microsoftIdToken;
  if (response.account.name) {
    attributes["name"] = response.account.name;
  } else {
    attributes["name"] = username;
  }
  if (picture) {
    attributes["picture"] = picture;
  }
  Auth.signUp({
    username,
    password: password_generator(16),
    attributes,
  })
    .then((user) => {
      // register
      // after successfully signup we need to continue with authentication so user is signed in automatically
      authenticateWithMicrosoftToken(username, microsoftIdToken);
    })
    .catch((error) => {
      // login
      // if user is already registered we continue with sign in
      if (error.code === "UsernameExistsException") {
        authenticateWithMicrosoftToken(username, microsoftIdToken);
      }
    });
}
export default signUpOrSignInWithMicrosoftToken;
